import { SocialButtonCommonStyles } from 'src/common/styles';
import styled from 'styled-components';

export const StyledTitle = styled.h3`
  margin-top: 2.5rem;
  margin-bottom: 0.56rem;
  text-align: center;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
`;

export const StyledSocialButtonsWrapper = styled.div<{ $forceColumn?: boolean }>`
  display: flex;
  flex-direction: column;
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: ${({ $forceColumn }) => ($forceColumn ? 'column' : 'row')};
  }

  gap: 1rem;
  justify-content: center;
`;

export const StyledSocialButton = styled.a`
  ${SocialButtonCommonStyles};
  height: 4.5rem;
  border-radius: ${({ theme }) => theme.radius.huge};
  padding: 1rem;

  svg {
    width: 2.4rem;
    height: 2.4rem;
    margin: 0;

    path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const StyledBigSocialButton = styled(StyledSocialButton)`
  height: 3.5rem;
  border-radius: ${({ theme }) => theme.radius.small};
  padding: 1rem 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  svg {
    height: 1.4rem;
    width: 1.4rem;
  }
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  text-align: center;
`;
